import React, { useState, useEffect } from 'react';

const  DeviceDealer_Form = ({ onSubmit, fpsId }) => {
  const [inputFpsId, setInputFpsId] = useState(''); 

  useEffect(() => {
    setInputFpsId(fpsId || '');
  }, [fpsId]);

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      input:-webkit-autofill,
      input:-webkit-autofill:hover,
      input:-webkit-autofill:focus,
      input:hover,
      input:focus {
        background-color: white !important;
        box-shadow: 0 0 0px 1000px white inset !important;
        -webkit-box-shadow: 0 0 0px 1000px white inset !important;
        caret-color: black !important;
      }
    `;
    document.head.appendChild(style);
  }, []);

  const NumericsOnly = (event) => {
    if ((event.which != 8 && event.which != 0 && (event.which < 48 || event.which > 57))) {
      event.preventDefault();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(inputFpsId);
  };

  const handleBack = () => {
    window.history.back();
  };

  return (
    <table width="25%">
      <tbody>
        <tr className="tableheader">
          <th colSpan="2">Device & Dealer</th>
        </tr>
        <tr>
          <td>FPS</td>
          <td>
            <input
              type="text"
              onMouseOver={(e) => e.target.select()}
              name="fps_id"
              id="fps_id"
              value={inputFpsId}
              onChange={(e) => setInputFpsId(e.target.value)}
              required
              onKeyPress={NumericsOnly}
              minLength="12"
              pattern=".{12,}"
              maxLength="12"
              autoFocus 
            />
          </td>
        </tr>
        <tr align="center">
          <td align="center" colSpan="2">
            <button onClick={handleSubmit} className="button button2" style={{ marginRight: "7px" }}>Submit</button>
            <button onClick={handleBack} className="button button2">Back</button>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default DeviceDealer_Form;






